import React from 'react';
import { ProcessStep } from '../../services/ProcessStepService';
import { ProcessStepMetadataModal } from './ProcessStepMetadataModal';

interface ConfigurationData {
  countries: Array<{ id: string; name: string }>;
  legalEntities: Array<{ id: string; name: string }>;
  supportingModels: Array<{ id: string; name: string }>;
  thirdPartyBusinessTypes: Array<{ id: string; name: string }>;
}

interface EditStepModalProps {
  isOpen: boolean;
  onClose: () => void;
  step: ProcessStep;
  onSave: (updateData: Partial<ProcessStep>) => Promise<void>;
  configurations: ConfigurationData;
}

export const EditStepModal: React.FC<EditStepModalProps> = ({
  isOpen,
  onClose,
  step,
  onSave,
  configurations
}) => {
  return (
    <ProcessStepMetadataModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      configurations={configurations}
      initialData={step}
    />
  );
};